import { z } from 'zod';
import { email, isoDate, uuid } from './common.js';

/** The consent page of a pending MCP authorization (issue #47), path only: no open redirect. */
export const OAUTH_AUTHORIZE_PAGE = '/oauth/authorize';
const oauthReturn = z
  .string()
  .regex(
    /^\/oauth\/authorize\?request=[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
  );

/** Where the magic link lands: the profile, the back office, or a pending MCP authorization. */
export const magicLinkRedirect = z.union([z.enum(['/me', '/admin']), oauthReturn]);
export type MagicLinkRedirect = z.infer<typeof magicLinkRedirect>;

export const requestMagicLinkInput = z.object({
  email,
  turnstileToken: z.string().min(1),
  redirectTo: magicLinkRedirect.default('/me'),
});
export type RequestMagicLinkInput = z.infer<typeof requestMagicLinkInput>;

export const verifyMagicLinkInput = z.object({
  token: z.string().min(32).max(256),
});

export const sessionUser = z.object({
  id: uuid,
  email,
  role: z.enum(['participant', 'admin']),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  createdAt: isoDate,
});
export type SessionUser = z.infer<typeof sessionUser>;
